// extracted by mini-css-extract-plugin
module.exports =  {"button":"_33974c2b58--button--oJ7i8","icon":"_33974c2b58--icon--MNShP"};